import { FaBriefcase, FaBoxes, FaCar, FaFileInvoiceDollar, FaIdCard, FaUserPlus, FaUsers } from 'react-icons/fa';

export const GUIDED_TOUR_STEPS = [
  {
    key: 'licences',
    title: 'Set up licences in My Profile',
    route: '/my-profile',
    actionLabel: 'Open My Profile',
    icon: FaIdCard,
    symbol: '01',
    roles: ['ROLE_SADMIN', 'ROLE_MANAGER', 'ROLE_CMANAGER', 'ROLE_FMANAGER', 'ROLE_EMPLOYEE', 'ROLE_FWORKER'],
    description:
      'Start in My Profile and open the Profile Management panels. The Licences / Memberships panel is where employees and managers track licence numbers, memberships, and expiry dates.',
    highlights: [
      'Keep professional licences current and visible in one place.',
      'Use this first so later job, roster, and compliance workflows stay accurate.',
    ],
  },
  {
    key: 'regos',
    title: 'Set up vehicle and equipment regos',
    route: '/company/vehicle-rego',
    actionLabel: 'Open Vehicle Rego',
    icon: FaCar,
    symbol: '02',
    roles: ['ROLE_SADMIN', 'ROLE_CMANAGER'],
    description:
      'Use Company > Vehicle/Equipment Rego to track registration details, due dates, and service information for vehicles and equipment used by your business.',
    highlights: [
      'Add registration numbers, states, service dates, and expiry or due dates.',
      'This keeps company compliance visible alongside workforce setup.',
    ],
  },
  {
    key: 'employees',
    title: 'Invite employees and resources',
    route: '/invite',
    actionLabel: 'Open Invite Employee',
    icon: FaUserPlus,
    symbol: '03',
    roles: ['ROLE_SADMIN', 'ROLE_MANAGER', 'ROLE_CMANAGER'],
    description:
      'Invite your employees and resources from the Employee menu. Once invited, manage them, update profiles, and prepare them for rostering, trade jobs, and onboarding.',
    highlights: [
      'Invite the team first so jobs, availability, leave, and assignments have real people attached.',
      'Follow up in Manage Employee to maintain the workforce record.',
    ],
  },
  {
    key: 'customers',
    title: 'Add customers before creating work',
    route: '/customer/add',
    actionLabel: 'Open Add Customer',
    icon: FaUsers,
    symbol: '04',
    roles: ['ROLE_SADMIN', 'ROLE_MANAGER', 'ROLE_CMANAGER'],
    description:
      'Add customers through the Customer menu so trade jobs, quotes, and invoices can be attached to the right people and businesses.',
    highlights: [
      'Capture core customer contact and business details early.',
      'Customers are a core prerequisite for the trade job workflow.',
    ],
  },
  {
    key: 'inventory',
    title: 'Add inventory items and materials',
    route: '/inventory/add',
    actionLabel: 'Open Add Inventory',
    icon: FaBoxes,
    symbol: '05',
    roles: ['ROLE_SADMIN', 'ROLE_MANAGER', 'ROLE_CMANAGER'],
    description:
      'Use Inventory > Add New Item to build the stock and materials list your team will use when creating and running trade jobs.',
    highlights: [
      'Store item numbers, SKU, quantity, supplier details, and pricing.',
      'Inventory setup supports better job costing and material planning.',
    ],
  },
  {
    key: 'trade-jobs',
    title: 'Create trade jobs after setup is ready',
    route: '/trade-job-create',
    actionLabel: 'Open Create a Job',
    icon: FaBriefcase,
    symbol: '06',
    roles: ['ROLE_SADMIN', 'ROLE_MANAGER', 'ROLE_CMANAGER', 'ROLE_EMPLOYEE'],
    description:
      'Once employees, customers, and inventory are ready, move to Trade Job > Create a Job. This is where those records come together into a working operational job.',
    highlights: [
      'Employees support allocations and execution.',
      'Customers define who the work is for.',
      'Inventory supports materials, costing, and delivery into the job.',
    ],
  },
  {
    key: 'quotes-invoices',
    title: 'Manage quotes and invoices from the workflow',
    route: '/accounting/invoices',
    actionLabel: 'Open Invoices',
    icon: FaFileInvoiceDollar,
    symbol: '07',
    roles: ['ROLE_SADMIN', 'ROLE_MANAGER', 'ROLE_CMANAGER', 'ROLE_FMANAGER'],
    description:
      'Quotes and invoices complete the operational cycle. After jobs and customers are in place, use the accounting and trade job flows to create, review, and send commercial documents.',
    highlights: [
      'Quotes help scope and win the work.',
      'Invoices convert completed or billable work into revenue.',
      'This stage depends on the earlier setup steps being completed well.',
    ],
  },
];